export const heroData = {
  badge: "66",
  title: "Viz App",
  features: [
    { icon: "Lock", text: "Fully Secure" },
    { icon: "Smartphone", text: "Mobile-Friendly" },
    { icon: "Palette", text: "Flexible Design" }
  ],
  description: "Web-based Smart Health Report application built with world-class UI/UX. Fast, secure, mobile-friendly, and designed for the modern digital healthcare ecosystem.",
  ctaText: "Try Now",
  ctaLink: "#"
};

export const servicesData = {
  title: "Our Smart Health Services",
  subtitle: "Influencer startup interaction design. Paradigm shift research & development partner network iteration lean startup return on investment.",
  features: [
    {
      icon: "ClipboardList",
      title: "Complete Report Coverage",
      description: "Unified view of all biomarkers with easy navigation. Ideal for doctors & patients.",
      details: [
        "Covers majority of biomarkers in hematology & biochemistry",
        "Detailed test-by-test insights",
        "Future-ready structure to add more parameters"
      ]
    },
    {
      icon: "Search",
      title: "Interactive & Searchable Profiles",
      description: "Search by test name, disease, or body part to instantly locate what matters to you.",
      details: [
        "Body map navigation",
        "Dynamic search panel & quick filters",
        "Personalized test insights"
      ]
    },
    {
      icon: "PlayCircle",
      title: "Smart Video Report",
      description: "Short, simplified video explaining key abnormalities & next actions.",
      details: [
        "Fast and easy to understand",
        "Doctor-friendly summary format",
        "Multilingual support"
      ]
    }
  ],
  riskAnalysis: {
    title: "AI Risk Analysis",
    description: "Understand long-term health risks with real-time scoring and visual analytics.",
    features: [
      "Smart risk score visualization",
      "QR-based access to complete risk profile",
      "+ Professional reporting format"
    ]
  }
};

export const processData = {
  title: "Our Smart Process",
  subtitle: "We convert medical complexity into clarity with a seamless digital experience",
  steps: [
    {
      number: 1,
      icon: "Upload",
      title: "Upload Report",
      description: "Upload or import your medical report easily from any lab",
      color: "#FF8C42"
    },
    {
      number: 2,
      icon: "BrainCircuit",
      title: "Smart AI Analysis",
      description: "Data interpreted through AI models for accurate insights",
      color: "#FF8C42"
    },
    {
      number: 3,
      icon: "LayoutDashboard",
      title: "Visual Insights Dashboard",
      description: "Understand your report visually instead of reading large data",
      color: "#FF8C42"
    },
    {
      number: 4,
      icon: "Lightbulb",
      title: "Personalized Recommendations",
      description: "AI suggests lifestyle, diagnostic or medical next steps",
      color: "#FF5722"
    },
    {
      number: 5,
      icon: "Share2",
      title: "Smart Report Sharing",
      description: "Share with doctor or family with a single click",
      color: "#2ECC71"
    }
  ]
};